import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/declaracaoAnalise/';

class DeclaracaoRetificacaoService{
  constructor() {
    LoginService.currentUser.subscribe(data => {
        this.headers = {
            'Content-Type':'application/json',
            'authorization':'Bearer ' + (data ? data.token:'')
        };
    });
  }

  retificarDeclaracaoAnalise(decAnalise){
    return axios.post(API_URL+'retificacaoAnalise', JSON.stringify(decAnalise), {headers: this.headers});
  }

  validarDeclaracao(idDeclaracao){
    return axios.post(API_URL+'validarDeclaracao?idDeclaracao='+idDeclaracao, null, {headers: this.headers});
  }
}

export default new DeclaracaoRetificacaoService();